import { render } from "./ExportFormats.vue?vue&type=template&id=2373fc71&scoped=true"
import script from "./ExportFormats.vue?vue&type=script&lang=js"
export * from "./ExportFormats.vue?vue&type=script&lang=js"

import "./ExportFormats.vue?vue&type=style&index=0&id=2373fc71&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2373fc71"]])

export default __exports__